import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23.29 10.24a1.4 1.4 0 0 0-2 .13l-7.45 8.46a.25.25 0 0 1-.28.07.26.26 0 0 1-.16-.23V1.41a1.41 1.41 0 0 0-2.82 0v17.26a.26.26 0 0 1-.16.23.25.25 0 0 1-.28-.07L2.7 10.37a1.41 1.41 0 0 0-2.12 1.86l9.65 11a2.36 2.36 0 0 0 3.54 0l9.65-11a1.41 1.41 0 0 0-.13-1.99Z"
}), 'ArrowDown');